import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/*
* Fitting
*
* new AutoFitting( 0,null,null,"");
*/
export default class AutoObjFitting {
    public index: number;

    public guid: string;

    public flr: number;

    public p: marietta.core.Point;

    public p1: marietta.core.Point;

    public p2: marietta.core.Point;

    public item: string;

    public rotation: number;

    public width: number;

    public widthmm: number;

    public height: number;

    public z: string;

    public auto: boolean;

    public usemm: boolean;

    public type: number;

    public reverse: boolean;

    constructor(flr: number, p1: marietta.core.Point, p2: marietta.core.Point, item: string) {
      this.index = 0;
      this.guid = marietta.webcad.WebCADGlobal.getGuid();
      this.flr = flr;
      if (p1 == null) {
        this.p = null;
      } else {
        this.p = p1.getMidPoint(p2);
      }
      this.p1 = p1;
      this.p2 = p2;
      this.item = item;
      if (p1 == null) {
        this.width = 0;
      } else {
        this.width = p1.distanceTo(p2);
      }
      this.widthmm = 0;
      this.height = 0;
      this.z = '';
      this.auto = true;
      this.usemm = false;
      if (p1 == null) {
        this.rotation = 0;
      } else {
        this.rotation = new marietta.core.Point(p1.x, p1.y, p1.flag).angle(new marietta.core.Point(p2.x, p2.y, p2.flag));
      }
      this.type = 0;
      this.reverse = false;
    }

    /*
    * 描画
    *
    */
    public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D) {
      const clBlack = '#000';
      const clGray = '#666';
      // const clBlue = '#00c';
      const clBrawn = '#900';
      // const clRed = '#f00';
      const clYellow = '#ff0';

      let cl = clYellow;
      switch (this.item) {
        case 'fit01_01': cl = clBlack; break;
        case 'fit01_02': cl = clGray; break; // 下り
        case 'fit01_03': cl = clBrawn; break; // 腰
        default: break;
      }
      /*
        if ( activeObj != null ) {
            if ( this == activeObj ) {
                cl = clRed;
            }
        }
        */
      const p3 = new marietta.core.Point(this.p.x, this.p.y + 10, 0);
      p3.rotation(this.p, this.rotation);
      const ip0 = sc.ConvertToCanvas(this.p);
      const ip1 = sc.ConvertToCanvas(this.p1);
      const ip2 = sc.ConvertToCanvas(this.p2);
      const ip3 = sc.ConvertToCanvas(p3);
      ctx.beginPath();
      ctx.strokeStyle = cl;
      ctx.lineWidth = 5;
      ctx.moveTo(ip1.x, ip1.y);
      ctx.lineTo(ip2.x, ip2.y);
      ctx.moveTo(ip0.x, ip0.y);
      ctx.lineTo(ip3.x, ip3.y);
      ctx.stroke();
    }

    /*
    * 玄関建具
    *
    */
    public IsGenkanTategu(): boolean {
      if (this.item === 'fit03_01'
            || this.item === 'fit05_01'
            || this.item === 'fit04_01'
            || this.item === 'fit07_01'
            || this.item === 'fit06_01'
            || this.item === 'fit09_01'
            || this.item === 'fit08_01'
            || this.item === 'fit14_01') {
        return true;
      }
      return false;
    }

    /*
    * ( p1 - p2 )に乗っていたら true
    *
    */
    public IsOnline(p1: marietta.core.Point, p2: marietta.core.Point): boolean {
      const ln1 = new marietta3d.AutoGen.utils.RoomEdge();
      ln1.CopyPointFrom(p1, p2);
      const ln2 = new marietta3d.AutoGen.utils.RoomEdge();
      ln2.CopyPointFrom(this.p1, this.p2);
      if (Math.abs(ln1.IsOverlapLine(ln2) - this.p1.distanceTo(this.p2)) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
        return true;
      }
      return false;
    }

    /*
    * Hit test
    *
    */
    public IsHit(mp: marietta.core.Point): boolean {
      const ln2 = new marietta3d.AutoGen.utils.RoomEdge();
      ln2.CopyPointFrom(this.p1, this.p2);
      if (ln2.DistancePtoEdge(mp) < 5) {
        return true;
      }
      return false;
    }

    /*
    * Move
    *
    */
    public Move(x: number, y: number) {
      this.p.x += x;
      this.p.y += y;
      this.p1.x += x;
      this.p1.y += y;
      this.p2.x += x;
      this.p2.y += y;
    }

    /*
    * XML
    *
    */
    public createXML(cnt: number): string {
      const lr = (this.reverse === true) ? '1' : '0';
      let xml = '';
      const m = (this.usemm === true) ? '1' : '0';
      const a = (this.auto === true) ? '1' : '0';
      xml = `${xml}<item id="${this.item}" f="${this.flr.toString()}" guid="${this.guid}" index="${cnt.toString()}"`;
      xml = `${xml} x="${this.p.x.toString()}" y="${this.p.y.toString()}" z="${this.z}"`;
      xml = `${xml} width="${this.width.toString()}" height="${this.height.toString()}" width_mm="${this.widthmm.toString()}"`;
      xml = `${xml} rotation="${this.rotation.toString()}" type="${this.type.toString()}"`;
      xml = `${xml} auto_height="${a}" use_mm="${m}" lr="${lr}"`;
      xml += '/>\n';
      return xml;
    }

    /*
    * XML
    *
    */
    public createXML2(doc: Document, nodeFit: Element, cnt: number) {
      const lr = (this.reverse === true) ? '1' : '0';
      const m = (this.usemm === true) ? '1' : '0';
      const a = (this.auto === true) ? '1' : '0';
      const nodeItem = doc.createElement('item');
      nodeFit.appendChild(nodeItem);
      nodeItem.setAttribute('guid', this.guid);
      nodeItem.setAttribute('index', cnt.toString());
      nodeItem.setAttribute('id', this.item);
      nodeItem.setAttribute('f', this.flr.toString());
      nodeItem.setAttribute('x', this.p.x.toString());
      nodeItem.setAttribute('y', this.p.y.toString());
      nodeItem.setAttribute('z', this.z);
      nodeItem.setAttribute('width', this.width.toString());
      nodeItem.setAttribute('height', this.height.toString());
      nodeItem.setAttribute('width_mm', this.widthmm.toString());
      nodeItem.setAttribute('rotation', this.rotation.toString());
      nodeItem.setAttribute('type', this.type.toString());
      nodeItem.setAttribute('auto_height', a);
      nodeItem.setAttribute('use_mm', m);
      nodeItem.setAttribute('lr', lr);
    }

    /*
    * XML
    *
    */
    public readXML(item: Element) {
      let elem: any;
      const rattr = item.attributes;

      this.flr = Number(rattr.getNamedItem('f').nodeValue);
      this.index = Number(rattr.getNamedItem('index').nodeValue);
      this.guid = rattr.getNamedItem('guid').nodeValue;
      this.item = rattr.getNamedItem('id').nodeValue;
      let reverse = 0;
      elem = rattr.getNamedItem('lr');
      if (elem != null) {
        reverse = Number(elem.nodeValue);
      }
      const x = Number(rattr.getNamedItem('x').nodeValue);
      const y = Number(rattr.getNamedItem('y').nodeValue);

      let wauto = 1;
      elem = rattr.getNamedItem('auto_height');
      if (elem != null) {
        wauto = Number(elem.nodeValue);
        this.auto = (wauto === 1);
      }
      // const z = 0;
      if (wauto === 1) {
        this.z = '0';
      } else {
        elem = rattr.getNamedItem('z');
        if (elem != null) {
          if (elem.nodeValue !== 'NaN') {
            this.z = elem.nodeValue;
            // z = Number(elem.nodeValue);
          }
        }
      }
      this.width = 0;
      elem = rattr.getNamedItem('width');
      if (elem != null) {
        this.width = Number(elem.nodeValue);
      }
      this.widthmm = 0;
      elem = rattr.getNamedItem('width_mm');
      if (elem != null) {
        this.widthmm = Number(elem.nodeValue);
      }
      this.height = 0;
      /* if (wauto === 1) {
      } */
      if (wauto !== 1) {
        elem = rattr.getNamedItem('height');
        if (elem != null) {
          if (elem.nodeValue !== 'NaN') {
            this.height = Number(elem.nodeValue);
          }
        }
      }
      let usemm = 0;
      elem = rattr.getNamedItem('use_mm');
      if (elem != null) {
        usemm = Number(elem.nodeValue);
      }
      this.rotation = 0;
      elem = rattr.getNamedItem('rotation');
      if (elem != null) {
        this.rotation = Number(elem.nodeValue);
      }
      this.type = 0;
      elem = rattr.getNamedItem('type');
      if (elem != null) {
        this.type = Number(elem.nodeValue);
      }
      this.auto = (this.height === 0);
      this.usemm = usemm !== 0;
      this.reverse = reverse !== 0;
      this.p = new marietta.core.Point(x, y, 0);
      this.p1 = new marietta.core.Point(x - (this.width / 2), y, 0);
      this.p2 = new marietta.core.Point(x + (this.width / 2), y, 0);
      this.p1.rotation(this.p, this.rotation);
      this.p2.rotation(this.p, this.rotation);
    }

    /*
    * JSON
    *
    */
    public readJson(item: any, buildingType:number = null) {
      let objVal: any;

      this.flr = Number(item.f);
      this.index = Number(item.index);
      this.guid = item.guid;
      this.item = item.id;
      let reverse = 0;
      objVal = item.lr;
      if (objVal != null) {
        reverse = Number(objVal);
      }
      let x = Number(item.x);
      let y = Number(item.y);
      if (buildingType !== null && buildingType === 1) {
        x = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(item.x));
        y = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(item.y));
      }

      let wauto = 1;
      objVal = item.auto_height;
      if (objVal != null) {
        wauto = Number(objVal);
        this.auto = (wauto === 1);
      }
      // const z = 0;
      if (wauto === 1) {
        this.z = '0';
      } else {
        objVal = item.z;
        if (objVal != null) {
          if (objVal !== 'NaN') {
            this.z = objVal;
            // z = Number(elem.nodeValue);
          }
        }
      }
      this.width = 0;
      objVal = item.width;
      if (objVal != null) {
        this.width = Number(objVal);
      }
      this.widthmm = 0;
      objVal = item.width_mm;
      if (objVal != null) {
        this.widthmm = Number(objVal);
      }
      this.height = 0;
      /* if (wauto === 1) {
      } */
      if (wauto !== 1) {
        objVal = item.height;
        if (objVal != null) {
          if (objVal !== 'NaN') {
            this.height = Number(objVal);
          }
        }
      }

      if (buildingType !== null && buildingType === 1) {
        this.width = marietta.webcad.util.WebCADUtil.convertMMToPix(this.width);
        this.height = marietta.webcad.util.WebCADUtil.convertMMToPix(this.height);
      }
      let usemm = 0;
      objVal = item.use_mm;
      if (objVal != null) {
        usemm = Number(objVal);
      }
      this.rotation = 0;
      objVal = item.rotation;
      if (objVal != null) {
        this.rotation = Number(objVal);
      }
      this.type = 0;
      objVal = item.type;
      if (objVal != null) {
        this.type = Number(objVal);
      }
      this.auto = (this.height === 0);
      this.usemm = usemm !== 0;
      this.reverse = reverse !== 0;
      this.p = new marietta.core.Point(x, y, 0);
      this.p1 = new marietta.core.Point(x - (this.width / 2), y, 0);
      this.p2 = new marietta.core.Point(x + (this.width / 2), y, 0);
      this.p1.rotation(this.p, this.rotation);
      this.p2.rotation(this.p, this.rotation);
    }
}
